// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"115b067e","734":"01eff8bf"}[chunkId] + ".chunk.js";
};